import { Switch, makeStyles } from "@material-ui/core";

import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../Context/Auth";
import { Instance } from "../../Context/axiosContext";

const useStyles = makeStyles((theme) => ({
  root: {
    width: 52,
    height: 26,
    padding: 0,
    margin: theme.spacing(1),
  },
  switchBase: {
    padding: 1,
    "&$checked": {
      transform: "translateX(26px)",
      color: theme.palette.common.white,
      "& + $track": {
        backgroundColor: "#6600ff",
        opacity: 1,
        border: "none",
      },
    },
    "&$focusVisible $thumb": {
      color: "#476b6b",
      border: "6px solid #fff",
    },
  },
  thumb: {
    width: 24,
    height: 24,
  },
  track: {
    borderRadius: 26 / 2,
    border: `1px solid ${theme.palette.grey[400]}`,
    backgroundColor: "rgba(68, 91, 110, 0.3)",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  checked: {},
  focusVisible: {},
}));

function LockSettingButton({ status, getRestStatus }) {
  const { setLockModal, lockModal } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const { user } = useContext(AuthContext);
  const axiosInstance = Instance();
  let url = process.env.REACT_APP_API_URL;
  const classes = useStyles();

  async function changeLockStatus(x) {
    setLoading(true);
    await axiosInstance
      .get(url + `locksetting?lockstatus=${x}`, {
        headers: {
          Authorization: user,
          ["x-api-key"]: localStorage.getItem("apikey"),
        },
      })
      .then(({ data }) => {
        console.log(data);
        setLoading(false);
        getRestStatus();
      })
      .catch((e) => {
        console.log("error", e.message);
        setLoading(false);
      });
  }

  async function setLock() {
    if (status === true) {
      setLockModal(true);
    } else {
      changeLockStatus(true);
    }
  }

  useEffect(() => {
    console.log("lockModal", lockModal);
    changeLockStatus(true);
    console.log("status", status);
    const activityTime = 900;
    let intervalId = null;
    function startActivityTimer() {
      intervalId = setTimeout(closeWebsite, activityTime * 1000);
    }
    function resetActivityTimer() {
      clearTimeout(intervalId);
      intervalId = setTimeout(closeWebsite, activityTime * 1000);
    }
    function closeWebsite() {
      if (status === false) {
        setLock();
      }
    }
    window.addEventListener("mousemove", resetActivityTimer);
    window.addEventListener("keypress", resetActivityTimer);
    startActivityTimer();
  }, []);
  return (
    <>
      <Switch
        focusVisibleClassName={classes.focusVisible}
        // disableRipple
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked,
        }}
        title="On"
        disabled={loading}
        checked={status}
        onClick={() => {
          setLock();
        }}
      />
    </>
  );
}

export default LockSettingButton;
